import React from 'react';
import type PolarisAccessSettingsPageType from '@atlassian/jira-spa-apps-polaris-settings-access/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAccessSettingsPage = lazyForPaint<typeof PolarisAccessSettingsPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-polaris-settings-access", jiraSpaEntry: "async-polaris-ideas" */ '@atlassian/jira-spa-apps-polaris-settings-access'
			),
		),
	{ ssr: false },
);

export const AccessSettingsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAccessSettingsPage}
		pageId="async-polaris-settings-access"
		shouldShowSpinner={false}
	/>
);
